<template>
	<!-- 파일 첨부 단건 -->
	<!-- 사용 예시 :src\views\qms\pqy\fcku\FwdCku\Content\Table\Form.vue -->
	<div class="qms-file-upload position-relative w-100 h-100">
		<div class="addScroll w-100 h-100 mr-5" :style="`width: ${width} !important; height: ${height} !important; `">
			<template v-if="setInit"> <input type="file" :accept="accept" :id="id" @change="onChange" ref="fileInput" /></template>
			<div class="w-100 pr-4 d-flex" style="height: 100%">
				<template v-if="fileObject.fileSeq">
					<div class="qms-file-upload__item mr-3 my-auto" style="text-align: left">
						<span class="file-upload__item__name" @click="onDownload">{{ fileName }}</span>
						<i class="icon-sf-circle-close" @click="deleteFile" v-show="isEditable" />
					</div>
				</template>
				<template v-else-if="fileExisted">
					<div class="qms-file-upload__temp mr-3 my-auto" style="text-align: left">
						<span class="file-upload__temp__name">{{ fileName }}</span>
						<i class="icon-sf-circle-close" @click="deleteFile" v-show="isDeletable" />
					</div>
				</template>
			</div>
		</div>
		<template v-if="isEditable">
			<label :for="id" class="unit input-icon"><i class="icon-sf-upload" /></label>
		</template>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { checkFileSize } from '@/qmsUtils';

export default {
	name: 'file-upload-list',
	props: {
		id: { type: String, default: '' + (Math.random() * 10000 + 1) },
		propFileObject: {
			type: [Object, File],
			default() {
				return {};
			}
		},
		slotPropsRow: {},
		width: { type: String, default: '100px' },
		height: { type: String, default: '100px' },
		isEditable: { type: Boolean, default: true },
		isDeletable: { type: Boolean, default: true },
		accept: { type: String, default: '*' } //파일 형식 제한할 경우
	},
	data() {
		return {
			setInit: true,
			fileObject: {}
		};
	},
	created() {
		this.fileObject = this.propFileObject || {};
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		fileExisted() {
			return this.fileObject.size > 0 || this.fileObject.fileSize > 0;
		},
		fileName() {
			if (this.fileExisted) {
				let flNm = this.fileObject.origFileName || this.fileObject.fileName || this.fileObject.name || '';
				const name = flNm.substring(0, Math.min(flNm.lastIndexOf('.'), 25));
				const ext = flNm.substring(flNm.lastIndexOf('.') + 1);
				return name + '.' + ext;
			} else return '';
		}
	},
	watch: {
		fileObject: {
			deep: true,
			handler() {
				this.$emit('singleFile', this.fileObject, this.slotPropsRow);
			}
		},
		propFileObject() {
			this.fileObject = this.propFileObject || {};
		}
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		init() {
			this.fileObject = {};
		},
		onChange({ target: { files } }) {
			try {
				this.setInit = false;
				if (!checkFileSize(files[0])) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC000063'), ['200']));
				}
				this.fileObject = files[0];
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$refs.fileInput.value = '';
				this.setInit = true;
			}
		},
		deleteFile() {
			this.setInit = false;
			const isNotTemp = !!this.fileObject?.fileSeq;
			if (isNotTemp) {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: this.deleteOne }]
				});
			} else {
				this.fileObject = {};
			}
			this.setInit = true;
		},
		async deleteOne() {
			try {
				this.$sf_toggleLoading(true);
				const { code, messageCd } = await this.deleteFile_({ fileId: this.fileObject.fileId, fileSeq: 1 });
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				this.fileObject = {};
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		onDownload() {
			if (this.fileObject.fileSeq) {
				this.$emit('onDownload', this.fileObject);
			}
		}
	}
};
</script>
